import type { ReactNode } from "react";
import { useNavigate } from "react-router";
import { useSession, useSignOut } from "../lib/session.js";
import { BottomNav, hasNavItems } from "./BottomNav.js";

export function AppShell({ title, children }: { title: string; children: ReactNode }) {
  const { data: me } = useSession();
  const signOut = useSignOut();
  const navigate = useNavigate();
  const showNav = !!me && hasNavItems(me.role);

  return (
    <div className="min-h-dvh bg-stone-50 text-stone-900">
      {/* "app-header" (not the bare `header` tag) is what @media print targets — InvoiceDocument
          has its own <header> for the document's own title block, which must survive printing. */}
      <header className="app-header sticky top-0 z-10 flex items-center justify-between border-b border-stone-200 bg-white/90 px-4 py-3 backdrop-blur">
        <h1 className="text-lg font-semibold">{title}</h1>
        {me ? (
          <button
            type="button"
            className="text-sm text-stone-500 underline"
            onClick={() => signOut.mutate(undefined, { onSuccess: () => navigate("/login", { replace: true }) })}
          >
            로그아웃
          </button>
        ) : null}
      </header>
      <main className={`mx-auto w-full max-w-screen-sm px-4 py-4 ${showNav ? "pb-24" : ""}`}>{children}</main>
      {showNav && me ? <BottomNav role={me.role} /> : null}
    </div>
  );
}
